<template>
  <div class="yuncang">
    <div
      class="searchTopBar"
      :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
    >
      <van-nav-bar
        title="品牌"
        left-arrow
        @click-left="goback()"
        right-text="搜索"
        @click-right="search()"
      >
        <template #title>
          <van-search
            v-model="keyWord"
            placeholder="请输入搜索关键词"
            @search="search()"
          />
        </template>
      </van-nav-bar>
    </div>
    <div class="historySearch">
      <h3>
        <span>历史搜索</span>
        <img @click="clear()" src="../../assets/yuncang/icon-09.png" alt="" />
      </h3>
      <ul>
        <li
          v-for="(item, index) in searchList.slice(0, 10)"
          :key="index"
          @click="toGoodeList(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isiOSX: false,
      keyWord: "",
      searchList: [],
    };
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    search() {
      if (this.keyWord) {
        this.searchList.unshift(this.keyWord);
        sessionStorage.setItem(
          "historyRecord",
          JSON.stringify(this.searchList)
        );
        this.$router.push({
          path: "/yuncang/goodsList",
          query: { keyWord: this.keyWord },
        });
      } else {
        this.$toast("请输入搜索内容");
      }
    },
    toGoodeList(name) {
      this.$router.push({
        path: "/yuncang/goodsList",
        query: { keyWord: name },
      });
    },
    clear() {
      sessionStorage.clear();
      this.searchList = [];
    },
  },
  created() {},
  mounted() {
    this.isiOSX = this.isIphoneX();
    if (sessionStorage.getItem("historyRecord")) {
      this.searchList = JSON.parse(sessionStorage.getItem("historyRecord"));
    }
  },
};
</script>
<style lang="less" scoped>
.yuncang {
  .historySearch {
    padding: 15px 16px;
    h3 {
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: #333333;
      line-height: 20px;
      display: flex;
      justify-content: space-between;
      img {
        width: 20px;
        height: 22px;
      }
    }
    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        margin-top: 13px;
        padding: 6px 12px;
        font-size: 15px;
        font-weight: 400;
        color: #666666;
        line-height: 21px;
        background: #f5f6f7;
        border-radius: 17px;
        margin-right: 12px;
      }
    }
  }
}
</style>
<style lang="less">
.yuncang {
  .searchTopBar {
    .van-icon-search::before {
      content: "";
      width: 19px;
      height: 19px;
      background: url("../../assets/yuncang/icon-07.png") no-repeat;
      background-size: 100%;
    }
    .van-field__left-icon {
      margin-right: 7px;
    }
    .van-field__control::-webkit-input-placeholder {
      color: #999999;
    }
    .van-field__control::-moz-placeholder {
      color: #999999;
    }
    .van-field__control::-moz-placeholder {
      color: #999999;
    }
    .van-field__control::-ms-input-placeholder {
      color: #999999;
    }
    .van-nav-bar {
      background: none;
      height: 44px;
      .van-nav-bar__left {
        .van-icon {
          color: #000;
          font-size: 18px;
          font-weight: bold;
        }
      }
      .van-nav-bar__title {
        font-size: 18px;
        color: #333333;
        font-weight: 600;
      }
    }
    [class*="van-hairline"]::after {
      border-bottom: none;
    }
    .van-nav-bar__title {
      max-width: 70%;
      width: 65%;
    }
    .van-nav-bar__text {
      color: #555555;
      font-size: 16px;
    }
    .van-search {
      height: 34px;
      line-height: 34px;
      border-radius: 17px;
      padding: 0px 0px;
      width: 100%;
      .van-search__content {
        background-color: #f2f2f2;
        border-radius: 17px;
      }
      .van-icon-search::before {
        content: "";
        width: 19px;
        height: 19px;
        background: url("../../assets/yuncang/icon-07.png") no-repeat;
        background-size: 100%;
      }
      .van-field__left-icon {
        margin-right: 7px;
      }
      .van-field__control {
        font-weight: normal;
      }
      .van-field__clear {
        color: #999999;
      }
      .van-field__control::-webkit-input-placeholder {
        color: #999999;
      }
      .van-field__control::-moz-placeholder {
        color: #999999;
      }
      .van-field__control::-moz-placeholder {
        color: #999999;
      }
      .van-field__control::-ms-input-placeholder {
        color: #999999;
      }
    }
  }
}
</style>